export default __webpack_public_path__ + "dca92c01f2b5862549fb30318cd86151.png";